import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Logo } from '../Logo';

const designers = [
  { name: 'Van Cleef & Arpels', slug: 'van-cleef-arpels' },
  { name: 'Cartier', slug: 'cartier' },
  { name: 'Tiffany & Co.', slug: 'tiffany-co' },
  { name: 'Bulgari', slug: 'bulgari' },
  { name: 'Harry Winston', slug: 'harry-winston' },
];

const guides = [
  { name: 'Authentication', slug: 'authenticate-luxury-jewelry' },
  { name: 'Condition Grades', slug: 'condition-grades-explained' },
  { name: 'Resale Value', slug: 'resale-value-guide' },
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#111] text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="container-editorial py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          
          {/* Brand Column */}
          <div className="lg:col-span-4">
            <div className="mb-6">
              <Logo variant="light" size="lg" linkTo="/" />
            </div>
            <p className="text-white/60 leading-relaxed mb-8 max-w-sm">
              Your trusted guide to buying pre-owned luxury jewelry from the world's most prestigious houses.
            </p>
            <a 
              href="mailto:hello@jewelryrefined.com" 
              className="inline-flex items-center gap-2 text-[#C69C6D] hover:text-white transition-colors"
            >
              hello@jewelryrefined.com
              <ArrowRight className="w-4 h-4" strokeWidth={1} />
            </a>
          </div>

          {/* Navigation Columns */}
          <div className="lg:col-span-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              
              {/* Designers */}
              <div>
                <p className="overline text-[#C69C6D] mb-6">Designers</p>
                <ul className="space-y-3">
                  {designers.map((designer) => (
                    <li key={designer.slug}>
                      <Link 
                        to={`/designers/${designer.slug}`}
                        className="text-sm text-white/60 hover:text-white transition-colors"
                      >
                        {designer.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Guides */}
              <div>
                <p className="overline text-[#C69C6D] mb-6">Guides</p>
                <ul className="space-y-3">
                  {guides.map((guide) => (
                    <li key={guide.slug}>
                      <Link 
                        to={`/guides/${guide.slug}`}
                        className="text-sm text-white/60 hover:text-white transition-colors"
                      >
                        {guide.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Company */}
              <div>
                <p className="overline text-[#C69C6D] mb-6">Company</p>
                <ul className="space-y-3">
                  <li>
                    <Link to="/about" className="text-sm text-white/60 hover:text-white transition-colors">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/methodology" className="text-sm text-white/60 hover:text-white transition-colors" data-testid="footer-methodology-link">
                      How We Verify
                    </Link>
                  </li>
                  <li>
                    <Link to="/glossary" className="text-sm text-white/60 hover:text-white transition-colors" data-testid="footer-glossary-link">
                      Glossary
                    </Link>
                  </li>
                  <li>
                    <Link to="/blog" className="text-sm text-white/60 hover:text-white transition-colors">
                      Articles
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" className="text-sm text-white/60 hover:text-white transition-colors">
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Legal */}
              <div>
                <p className="overline text-[#C69C6D] mb-6">Legal</p>
                <ul className="space-y-3">
                  <li>
                    <Link to="/affiliate-disclosure" className="text-sm text-white/60 hover:text-white transition-colors">
                      Affiliate Disclosure
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacy" className="text-sm text-white/60 hover:text-white transition-colors">
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link to="/terms" className="text-sm text-white/60 hover:text-white transition-colors">
                      Terms of Use
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container-editorial py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © {currentYear} Jewelry Refined. All rights reserved.
          </p>
          <p className="text-xs text-white/40">
            Made with expertise in New York, NY
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
